/**
 * @prettier
 */
// Relative Imports
import listingExtendedActions from '../actions/listingExtendedActions';
import edapActions from '../actions/edapActions';
import {log as logToServer} from '../api/logger';
import {badgesGraphQl} from '../api/badgesGraphQl';
import {unitSpacesGraphQl} from '../api/unitSpacesGraphQl';
import {contentItemsGraphQl} from '../api/contentItemsGraphQl';
import {urgencyMessageGraphQl} from '../api/urgencyMessageGraphQl';
import {getImageMetadata} from '../api/imageMetadata';
import getUnitId from '../utils/getUnitId';
import {isInBucket} from '../utils/abacusHelper';
import {logAmenitiesData} from './utils/logAmenitiesData';

async function fetchUrgencyMessage(store, action = {payload: {}}) {
    const {
        listingReducer: {unitApiUrl},
        systemReducer: {locale}
    } = store.getState();
    const {arriveDateText, departDateText} = action.payload;
    const unitUuid = getUnitId(unitApiUrl, false);

    let data = await urgencyMessageGraphQl({
        unitUuid,
        startDate: arriveDateText,
        endDate: departDateText,
        locale
    });
    store.dispatch(listingExtendedActions.fetchUrgencyMessageSuccess(data));

    if (data) {
        store.dispatch(
            edapActions.triggerEdapEvent('generic.event', {
                eventaction: 'pdp urgency scarcity test',
                eventcategory: 'pdp page'
            })
        );
    }
}

function fetchBadges(store) {
    const {
        listingReducer: {listingId},
        systemReducer: {locale}
    } = store.getState();

    return badgesGraphQl({listingId, locale}).then((data) => {
        const badgesData = data && data.badges;

        store.dispatch(listingExtendedActions.fetchBadgesSuccess(badgesData));
    });
}

function fetchUnitSpaces(store) {
    const {
        listingReducer: {listingId},
        systemReducer: {locale}
    } = store.getState();

    return unitSpacesGraphQl({listingId, locale}).then((data) => {
        const unitSpacesData = data && data.unitSpaces;

        store.dispatch(listingExtendedActions.fetchUnitSpacesSuccess(unitSpacesData));
    });
}

async function fetchContentItems(store) {
    const {
        listingReducer: {listingId, amenities, featuredAmenities},
        systemReducer: {locale}
    } = store.getState();

    const data = await contentItemsGraphQl({listingId, locale});

    if (data.errorCode) return;

    const unitContentItemsData = data && data.unitContentItems;
    const propertyContentItemsData = data && data.propertyContentItems;
    const unitMetadataData = data && data.unitMetadata;

    logAmenitiesData(
        listingId,
        {amenities, featuredAmenities},
        {
            unitContentItemsData,
            propertyContentItemsData,
            unitMetadataData
        }
    );

    store.dispatch(
        listingExtendedActions.fetchContentItemsSuccess(
            unitContentItemsData,
            propertyContentItemsData,
            unitMetadataData
        )
    );
}

async function fetchImageMetadata(store) {
    const state = store.getState();
    const listing = state.listingReducer;
    const {propertyApiUrl, listingId} = listing;

    let response;

    if (!isInBucket('ha_pdp_imageMetadataService')) {
        return;
    }

    try {
        response = await getImageMetadata({propertyApiUrl, listingId});
    } catch (error) {
        logToServer({
            fetchImageMetadata: false,
            error: error && error.response && error.response.body
        });

        return;
    }

    if (!response.body) {
        return;
    }

    store.dispatch(listingExtendedActions.fetchImageMetadataSuccess(response.body));
}

export default fetchUrgencyMessage;
export {fetchBadges, fetchUnitSpaces, fetchContentItems, fetchUrgencyMessage, fetchImageMetadata};
